/******************************************************************************
 *** BgtSpcAtrzDpstList ** 특별회계기금 결재 상신 * 수입결의서 리스트
*******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import GridTable, { fldInfsProps } from "@/js/common/ui/GridTable";
import Modal from "@/js/common/ui/modal/Modal";
import AdminGridStyle from "@/js/common/ui/style/AdminGridStyle";
import Util from "@/js/common/Util";
import React from "react";
import DialogTitleBar from "../../common/DialogTitleBar";
import BgtSpcDpstViewDialog from "./dialog/BgtBrDpstViewDialog";

interface Props {
    ognzCd    : string;  // 조직코드(지부)
    acntgYear : string;  // 회계연도
    systemCode: string;  // 시스템코드
    searchKywd: string;  // 검색어(적요)
    callTime  : Date;
    setProcBgtSbjctSeCd: Function; // 구분코드
    incomeCheckArr: any[];  // 체크된 수입결의서 Array
    setIncomeCheckArr: React.Dispatch<React.SetStateAction<any[]>>;
    setSpcAtrzTitleDialogOpen: Function;
    atrzProcessing: boolean;
}
const BgtSpcAtrzDpstList = ( {ognzCd, acntgYear, systemCode, searchKywd, callTime, setProcBgtSbjctSeCd, incomeCheckArr, setIncomeCheckArr, setSpcAtrzTitleDialogOpen, atrzProcessing}: Props ) => {
    const [incomeDataArr , setIncomeDataArr ] = React.useState<any[]>([]); // 수입결의서 목록
    const [sumIncomeAmt  , setSumIncomeAmt  ] = React.useState<string>("");  //조합비 수입내역 합계

    const [spcDpstModalOpen , setSpcDpstModalOpen] = React.useState<boolean>(false); // 수입결의서 상세정보 모달
    const [spcAcntgDpstDocId, setSpcAcntgDpstDocId] = React.useState<string>(""); // 수입결의서 문서번호

    // GridTable 컬럼 정의
    const incomeFldInfs: fldInfsProps[] = [
        { type: "date" , fldNm: "dpstDt"           , width: 120, headAlign: "center", dataAlign: "center", label: "수입일자" },
        { type: "text" , fldNm: "bgtSbjct1stNm"    , width: 120, headAlign: "center", dataAlign: "center", label: "관"       },
        { type: "text" , fldNm: "bgtSbjct2stNm"    , width: 120, headAlign: "center", dataAlign: "center", label: "항"       },
        { type: "text" , fldNm: "bgtSbjct3stNm"    , width: 120, headAlign: "center", dataAlign: "center", label: "목"       },
        { type: "text" , fldNm: "abstrCn"          , width: 190, headAlign: "center", dataAlign: "left"  , label: "적요"     },
        { type: "comma", fldNm: "dpstAmt"          , width: 120, headAlign: "center", dataAlign: "right" , label: "금액"     },
        { type: "text" , fldNm: "atrzSttsNm"       , width:  80, headAlign: "center", dataAlign: "center", label: "진행상태" },
        { type: "text" , fldNm: "crtDt"            , width: 120, headAlign: "center", dataAlign: "center", label: "작성일시" },
        { type: "text" , fldNm: "dpstRsdocNo"      , width: 140, headAlign: "center", dataAlign: "center", label: "문서번호" },
    ];

    // 특별회계기금 수입결의서 결재상신 목록 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/spc/atrz/select-bgt-spc-atrz-rtso-dpst-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                orgCd         : ognzCd    , // 조직코드
                acntgYear     : acntgYear , // 회계연도
                spcAcntgSeCd  : systemCode, // 시스템ID
                prcsAtrzSttsCd: "02"      , // 진행상태정보(작성완료[02])
            },
            onSuccessFn: (res: any) => {
                setIncomeDataArr(res.result.list);
                setSumIncomeAmt(res.result.listSum.sumDpstAmt);
                AppContext.hideSpinner();
            },
        });
    }, [ognzCd, acntgYear, systemCode, callTime]);

    React.useEffect(() => {
        let sum = 0;
        for (const row of Util.filterFieldData(incomeDataArr, incomeFldInfs, "abstrCn", searchKywd)) {
            sum += Number(row.dpstAmt) || 0;
        }
        setSumIncomeAmt(Util.comma(String(sum)));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [incomeDataArr, searchKywd]);

    // 결재상신
    function goApproval() {
        if (incomeCheckArr.length === 0) {
            AppContext.openAlert({ title: "수입결의서 선택 확인", msg: "결재상신할 수입결의서를 선택하세요.", icon: "warning" }); return;
        }
        setProcBgtSbjctSeCd("01"); // 구분코드(수입[01])
        setSpcAtrzTitleDialogOpen(true);
    }

    return (
        <div className="bd1d9d9d9 bdrd6 bgcWhite p15">
            <div className="dpFlx aiC jcSb mb10 h44">
                <span className="fm-b fs16 fc007bff ls1 fw700">수입 결의서</span>
                {/* 결재상신 버튼 */}
                <div className="dpFlx">
                    <Button buttonName="결재 상신"
                        width={140} height={40}
                        fontFamily="fm-b" fontSize={16} letterSpacing={-1}
                        variant="styCompleteBtn" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        disabled={atrzProcessing}
                        onClickFunc={() => goApproval()}
                    />
                </div>
            </div>

            {/* 그리드 */}
            <GridTable
                tableInfo={{
                    tableHeadVsb: true,
                    styleType: AdminGridStyle,
                    fldInfs: incomeFldInfs,
                    ordFld: { name: "dpstDt", direction: "desc" },
                    dataArr: Util.filterFieldData(incomeDataArr, incomeFldInfs, "abstrCn", searchKywd),
                    maxRowNums: [50],
                    theadTrHeight: 40,
                    tbodyTrHeight: 35,
                    paginateClass: "pt10",
                    paginateStyle: {
                        buttonOnColor: AppContext.boardThemeColor,
                        buttonWidth: 22, buttonHeight: 24,
                        buttonMarginLeft: 1, buttonMarginRight: 1,
                        fontSize: 13, color: "#666666", letterSpacing: -0.8, fontFamily: "Pretendard-Regular",
                        borderRadius: 3,
                    },
                    footerVsb: false, // 페이징 끄기
                    checkedHookParam: {
                        checkDataArr: incomeCheckArr,
                        setCheckDataArr: setIncomeCheckArr,
                    },
                    rowClickFunc: (item: any) => {  // row click
                        setSpcAcntgDpstDocId(item.spcAcntgDpstDocId);
                        setSpcDpstModalOpen(true);
                    },
                }}
            />

            {/* 합계 라인 (그리드 아래 별도 테이블) */}
            <table className="w100p bgcDCDCDC">
                <colgroup>
                    <col style={{width: "35px" }}></col>
                    <col style={{width: "120px"}}></col>
                    <col style={{width: "120px"}}></col>
                    <col style={{width: "120px"}}></col>
                    <col style={{width: "120px"}}></col>
                    <col style={{width: "190px"}}></col>
                    <col style={{width: "120px"}}></col>
                    <col style={{width: " 80px"}}></col>
                    <col style={{width: "120px"}}></col>
                    <col style={{width: "140px"}}></col>
                </colgroup>
                <tbody>
                    <tr style={{height: "35px"}}>
                        <td colSpan={2}></td>
                        <td colSpan={3} style={{textAlign: "center"}}>
                            <span className="fm-c fs15 ls06 fc2c3e50">합계</span>
                        </td>
                        <td colSpan={2} style={{textAlign: "right", paddingRight: "5px"}}>
                            <span className="fs15 ls075">{Util.comma(sumIncomeAmt)}</span>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>

            {/* 수입결의서 상세정보 모달 */}
            <Modal modalOpen={spcDpstModalOpen} dim={true} visible={true}
                titleEl={<DialogTitleBar title="수입결의서 상세정보" />}
                onCloseFunc={() => {
                    setSpcAcntgDpstDocId("");
                    setSpcDpstModalOpen(false);
                }}
            >
                <BgtSpcDpstViewDialog
                    spcAcntgDpstDocId  = {spcAcntgDpstDocId}   // 수입결의서 문서 ID
                    systemCode         = {systemCode}          // 시스템코드
                    setSpcDpstModalOpen= {setSpcDpstModalOpen}
                />
            </Modal>

        </div>
    )
}

export default BgtSpcAtrzDpstList;